import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { availableLanguages, getLocale } from "../../../../../common/parameters";

import { IUser } from "../../../../store/user/models";
import { IStateTree } from "../../../../store/interfaces";
import Modal from "../../../Modal";
import Form, { InputText, Submit, Cancel, Title } from "../../../Form";

import messages from "./messages";
import { IProps } from "./interfaces";

const RenamePlan = ({
    planName,
    loading,
    changeName,
    close,
    rename,
    validationPlanName,
    isHomework,
    isAdmin = false,
}: IProps) => {
    const user = useSelector((state: IStateTree) => state).user as IUser;

    const { formatMessage, locale } = useIntl();
    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    {isHomework ? <FormattedMessage {...messages.titleHomework} /> : <FormattedMessage {...messages.title} />}
                </Title>
                <InputText
                    label={isHomework ? formatMessage(messages.labelHomework) : formatMessage(messages.label)}
                    value={planName[getLocale(locale)] || ""}
                    name={getLocale(locale)}
                    onChange={changeName}
                    selectAllOnMount
                    validation={validationPlanName[getLocale(locale)]}
                />
                {(user.permission > 1 || isAdmin) &&
                    !isHomework &&
                    [...availableLanguages, "en"].map(lang => {
                        if (lang === locale) return null;
                        if (lang !== getLocale(lang)) return;
                        return (
                            <InputText
                                key={lang}
                                label={formatMessage(messages.label) + " " + lang.toUpperCase()}
                                value={planName[lang] || ""}
                                name={lang}
                                onChange={changeName}
                                validation={validationPlanName[lang]}
                            />
                        );
                    })}
                <Submit onClick={rename} loading={loading}>
                    <FormattedMessage {...messages.rename} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default RenamePlan;
